module.exports = __webpack_public_path__ + "img/locator-key.c7d1752b.png";